<template>
  <v-card outlined>
    <v-card-title>Метки пользователя</v-card-title>

    <v-divider />

    <v-card-text>
      <edit-user-tag v-model="user" :user="user" @update="updateTags" />

      <v-simple-table class="mt-2">
        <thead>
          <tr>
            <th>Активный</th>
            <th>Название</th>
            <th>Точка доступа</th>
            <th>Действия</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="obj in user.tags" :key="obj.tagId">
            <td>
              <v-simple-checkbox
                :value="obj.active"
                @click="changeActivation(obj)"
              />
            </td>
            <td>{{ getTagName(obj.tagId) }}</td>
            <td>{{ tagAccessPointName(obj.tagId) }}</td>
            <td>
              <v-btn icon @click="deleteUserTag(obj.tagId)">
                <v-icon color="red">mdi-delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
import EditUserTag from "../EditUserTag";
import {
  createUserTag,
  deleteUserTag,
  updateUserTag
} from "@/services/tags.service";
import { getTags } from "@/services/tags.service";

export default {
  name: "UserTags",
  components: { EditUserTag },
  model: { prop: "user", event: "update" },
  props: { user: { type: Object, required: true } },

  data: () => ({
    tags: []
  }),

  mounted() {
    this.getTags();
  },

  methods: {
    async getTags() {
      try {
        this.tags = await getTags();
      } catch (e) {
        this.$notify({
          text: e.response ? e.response.data.message : e,
          type: "error"
        });
      }
    },

    getTagName(tagId) {
      const tag = this.tags.find(t => t.id === tagId);
      return tag ? tag.name : "#" + tagId;
    },

    tagAccessPointName(tagId) {
      const tag = this.tags.find(t => t.id === tagId);
      return tag && tag.accessPoint ? tag.accessPoint.name : "—";
    },

    async changeActivation(obj) {
      obj.active = !obj.active;
      await updateUserTag(this.user.id, obj);
      this.updateTags();
    },

    async deleteUserTag(tagId) {
      await deleteUserTag(this.user.id, tagId);
      this.updateTags();
    },

    updateTags() {
      this.$emit("update", this.user);
    }
  }
};
</script>
